import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgColor from '../../../components/svg-color';
import PaymentIcon from '@mui/icons-material/Payment';
import AssessmentIcon from '@mui/icons-material/Assessment';



const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  payment: icon('ic_payment'),
};

const navConfig = [
  {
    subheader: '',
    items: [{ title: 'dashboard', path: PATH_DASHBOARD.general.dachboard, icon: ICONS.analytics }],
  },
  {
    subheader: '',
    items: [
      {
        title: 'invoice',
        path: PATH_DASHBOARD.invoice.root,
        icon: ICONS.invoice,
        children: [
          { title: 'Create Invoice', path: PATH_DASHBOARD.invoice.new },
          { title: 'list', path: PATH_DASHBOARD.invoice.list },
          { title: 'Draft Invoices', path: PATH_DASHBOARD.invoice.draft },
        ],
      },
    ],
  },
  {
    subheader: '',
    items: [
      {
        title: 'Payments',
        path: PATH_DASHBOARD.payment.root,
        icon: <PaymentIcon />,
        children: [
          { title: 'Pending Payments', path: PATH_DASHBOARD.payment.pending },
          { title: 'Payment History', path: PATH_DASHBOARD.payment.list },
        ],
      },
      {
        title: 'Assesments',
        path: PATH_DASHBOARD.assesment.list,
        icon: <AssessmentIcon />,
      },
    ],
  },
];

export default navConfig;
